import MDB from '@core/marketingdb';

/**
 * Append the given filter collection to the URL as part of the querystring
 *
 * @param {String} url
 * @param {Object[]} filters
 * @param {String} [filters.filterId]
 * @param {String} [filters.attributeId]
 * @param {String[]|String} filters.values
 *
 * @param {Boolean} [filters.inverted]
 * @param {Boolean} [filters.priority]
 *
 * @return {String}
 */
const appendFiltersToUrl = (url, filters) => MDB.Charts.appendFiltersToUrl(url, filters);

/**
 * Helper class for building DNX dashboard URLs throughout the application
 */
class DashboardUrlBuilder {
  static get FILTER_DIVISION_ID() { return 'selectedDivisionId' }
  static get FILTER_START_DATE() { return 'startDate' }
  static get FILTER_END_DATE() { return 'endDate' }

  /**
   * Create a new dashboardUrl builder for the given dashboard
   * @param dashboardId
   */
  constructor(dashboardId) {
    this._dashboardId = dashboardId;
    this._filters = [];
  }

  /**
   * Append a DashboardFilter to the dashboard URL
   * @param {String} filterId
   * @param {String[]|String} values
   * @returns {DashboardUrlBuilder}
   */
  withDashboardFilter(filterId, values) {
    //Ignore filters without a filterId/value
    if(
      !filterId ||
      values === undefined ||
      values === '' || //Should empty strings be ignored?
      (Array.isArray(values) && !values.length)
    ) {
      return this;
    }

    this._filters.push({
      filterId,
      values
    });

    return this;
  }

  /**
   * Get the URL to the configured dashboard with the configured parameters 
   * @returns {String}
   */
  getUrl() {
    let url = '/dashboard/index/';
    if(this._dashboardId) {
      url += this._dashboardId;
    }
    
    return appendFiltersToUrl(url, this._filters);
  }
}

export {
  DashboardUrlBuilder
};